/**
 * @generated SignedSource<<f3acf6b416428f6d33a4d0b0599ad62e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavHelp_seller$data = {
  readonly sellerRep: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentType": "NavHelp_seller";
};
export type NavHelp_seller$key = {
  readonly " $data"?: NavHelp_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavHelp_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavHelp_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RepData",
      "kind": "LinkedField",
      "name": "sellerRep",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "c4cd54aefae6d9b1203f8453afb28167";

export default node;
